// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3GNta","title":"FrontImage_title__1A6Rk"};